module.exports = __webpack_public_path__ + "static/img/bjl.8b1ac26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/bjl.png
// module id = gMea
// module chunks = 0